module.exports = __webpack_public_path__ + "static/media/Equatorial Guinea.38b1e69a.png";